import { Center, Circle, Grid, Stack, Text, Tooltip } from '@chakra-ui/react';
import { Column } from '@gamma/ui/layout';
import { ModelSummaryContribution } from '@investigator/features/detections/queries';
import { chartColorsByArraySize } from '@investigator/features/investigations/utils';
import { i18n } from '../../localization';

import { smartNumber } from '@investigator/features/investigations/components';

const { detection } = i18n.pages.detections;

export interface TopFeatureContributionsProps {
  features: ModelSummaryContribution[];
}

export const TopFeatureContributions = ({
  features,
}: TopFeatureContributionsProps) => {
  const { title } =
    i18n.pages.entityDetails.ml.analysis.cards.topFeatureContributions;

  const colors = chartColorsByArraySize(features?.length || 0);

  if (!features) {
    return null;
  }

  return (
    <Column col={5} display="flex" flexDir="column" justifyContent="start">
      <Text textStyle="h6" data-testid="top-feature-contributions-title">
        {title}
      </Text>
      <Stack spacing={0} paddingTop="80px">
        {features.map(
          (
            {
              description,
              contribution,
              display_name,
              feature_name,
            }: ModelSummaryContribution,
            index,
          ) => (
            <Center
              h="50px"
              key={index}
              data-testid="top-feature-contributions"
            >
              <Tooltip
                color="text.primary"
                label={
                  <Text
                    data-testid={`top-feature-contributions-value-${index}`}
                  >
                    {display_name || feature_name}
                    <br />
                    <br />
                    {description || detection.noDescriptionForFeature}
                  </Text>
                }
              >
                <Grid
                  w="full"
                  p={2}
                  layerStyle="second"
                  borderRadius="base"
                  alignItems="center"
                  templateColumns={'max-content 40px minmax(0, 1fr)'}
                  gap={2}
                >
                  <Circle size={2} bg={colors[index]} />
                  <Text
                    textStyle="body-md"
                    data-testid={`top-feature-contributions-percentage-${colors[index]}`}
                  >{`${(smartNumber(contribution) * 100).toFixed(0)}%`}</Text>
                  <Text
                    textStyle="body-md"
                    overflow="hidden"
                    whiteSpace="nowrap"
                    textOverflow="ellipsis"
                  >
                    {display_name || feature_name}
                  </Text>
                </Grid>
              </Tooltip>
            </Center>
          ),
        )}
      </Stack>
    </Column>
  );
};
